import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { MAX_SHIPPING_INSTRUCTIONS_LENGTH } from "@thkStore/Common/Constants/ShippingConstants";

type HandlerType = Handler<{ shippingInstructions: string }>;

export const DispatchSetShippingInstructions: HandlerType = props => {
    const value = (props.parameter.shippingInstructions ?? "").slice(0, MAX_SHIPPING_INSTRUCTIONS_LENGTH);
    props.dispatch({
        type: "Shipping/SetShippingInstructions",
        shippingInstructions: value,
    });
};

export const chain = [DispatchSetShippingInstructions];

const setShippingInstructions = createHandlerChainRunner(chain, "SetShippingInstructions");
export default setShippingInstructions;
